
import {
  FETCHING_COUNTRIES,
  FETCHING_COUNTRIES_FAILED,
  FETCHING_COUNTRIES_SUCCESSFUL,

  FETCH_USERS_COUNTRY,
  FETCH_USERS_COUNTRY_FAILED,
  FETCH_USERS_COUNTRY_SUCCESS,

  FETCH_COUNTRY_DONATION_SUMMARY,
  FETCH_COUNTRY_DONATION_SUMMARY_FAILED,
  FETCH_COUNTRY_DONATION_SUMMARY_SUCCESS,

  FETCH_COUNTRY_SLIDER_STATE,
  FETCH_COUNTRY_SLIDER_STATE_FAILED,
  FETCH_COUNTRY_SLIDER_STATE_SUCCESS,

  FETCH_VACCINATIONS,
  FETCH_VACCINATIONS_FAILED,
  FETCH_VACCINATIONS_SUCCESS,
} from "./types";
import  reduceArray from '../../utils/reduceArray';

export const initialState = {
    fetchingCountries: false,
    countries: [],
    countrySelectOptions: [],
    countryMap: {},
    fetchingUsersCountry: false,
    usersCountry: {},
    countryNameMap: {},
    countryDonationSummary: {},
    fetchingDonationSummary: false,
    sliderState: {},
    fetchingSliderState: false,
    fetchingVaccinations: false,
    countryVaccinations: {

    }
};

export const countryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COUNTRY_SLIDER_STATE_FAILED: return ({
      ...state,
      fetchingSliderState: false,
    })
    case FETCH_COUNTRY_SLIDER_STATE_SUCCESS: return ({
      ...state,
      fetchingSliderState: false,
      sliderState: action?.state,
    });
    case FETCH_COUNTRY_SLIDER_STATE: return ({
      ...state,
      fetchingSliderState: true,
    })
    case FETCH_COUNTRY_DONATION_SUMMARY: return ({
      ...state,
      fetchingDonationSummary: true
    });
    case FETCH_COUNTRY_DONATION_SUMMARY_FAILED: return ({
      ...state,
      fetchingDonationSummary: false,
    });
    case FETCH_COUNTRY_DONATION_SUMMARY_SUCCESS: return ({
      ...state,
      fetchingDonationSummary: false,
      countryDonationSummary: action?.summary
    })
    case FETCHING_COUNTRIES:
      return {
        ...state,
        fetchingCountries: true,
      };
    case FETCHING_COUNTRIES_FAILED:
      return {
        ...state,
        fetchingCountries: false,
      };
    case FETCHING_COUNTRIES_SUCCESSFUL:
      return {
        ...state,
        fetchingCountries: false,
        countries: action?.countries,
        countryNameMap: reduceArray(action?.countries, 'name'),
        countryMap: reduceArray(action?.countries, 'content.id'),
        countrySelectOptions: action?.countries?.map((country) => ({value: country?.content?.id, displayedValue: country?.name})),
      };
      case FETCH_USERS_COUNTRY: return ({
        ...state,
        fetchingUsersCountry: true
      });
      case FETCH_USERS_COUNTRY_FAILED: return ({
        ...state,
        fetchingUsersCountry: false
      });
      case FETCH_USERS_COUNTRY_SUCCESS: return ({
        ...state,
        fetchingUsersCountry: false,
        usersCountry: action?.country
      });
      case FETCH_VACCINATIONS: {
        return ({
          ...state,
          fetchingVaccinations: true,
        })
      }
      case FETCH_VACCINATIONS_FAILED: {
        return ({
          ...state,
          fetchingVaccinations: false,
        })
      }
      case FETCH_VACCINATIONS_SUCCESS: {
        return ({
          ...state,
          fetchingVaccinations: false,
          countryVaccinations: {
            ...state.countryVaccinations,
            [action?.vaccination?.country?.toLowerCase()]: Object.values(action?.vaccination?.timeline)[0] || 0
          }
        })
      }
    default:
      return state;
  }
};